<template>
    <div>
        <div :class="contentClass">
            <div class="grid-content">
                <div class="grid-item grid-item-half">
                    <r-input
                        label="Min"
                        v-model="min"
                        :validate="$v.min"
                        @key-submit="applyFilter"
                    />
                </div>
                <div class="grid-item grid-item-half">
                    <r-input
                        label="Max"
                        :validate="$v.max"
                        v-model="max"
                        @key-submit="applyFilter"
                    />
                </div>
            </div>
            <div class="grid-content" v-if="$v.$error">
                <div class="grid-item">
                    <v-error-messages>
                        <li class="list-item" v-if="!$v.min.required">At least one value must be defined</li>
                        <li class="list-item" v-if="!$v.min.decimal">The minimum value must be numeric</li>
                        <li class="list-item" v-if="!$v.max.decimal">The maximum value must be numeric</li>
                        <li class="list-item" v-if="!$v.min.optionalBetween || !$v.max.optionalBetween">The minimum
                            value must be lower or equal to the maximum value.
                        </li>
                    </v-error-messages>
                </div>
            </div>
        </div>
        <filter-footer
            @apply-filter="applyFilter"
            @cancel-filter="cancelFilter"/>
    </div>
</template>

<script>
    import {vErrorMessages} from '@/components/form';
    import FilterFooter from '@/modules/rules-engine/components/condition-builder/filters/filter-footer';
    import BaseFilterMixin from '@/modules/rules-engine/components/condition-builder/filters/base-filter-mixin';
    import decimal from 'vuelidate/lib/validators/decimal';
    import optionalBetween from '@/components/vuelidate/validators/optional-between';
    import _ from '@/common/helpers';
    import CriteriaCondition from '@/components/query/spec/criteria-condition';
    import ConditionOperators from '@/components/query/spec/condition-operators';
    import {requiredIf} from 'vuelidate/lib/validators';

    export default {
        name: 'numeric-filter',
        mixins: [BaseFilterMixin],
        components: {
            FilterFooter,
            vErrorMessages,
        },
        data() {
            return {...this.getInitialState()};
        },
        validations: {
            /* eslint-disable func-names */
            min: {
                required: requiredIf(model => _.isBlank(model.max)),
                decimal,
                optionalBetween: optionalBetween('max', function (min) {
                    return Number(min) <= Number(this.max);
                }),
            },
            max: {
                required: requiredIf(model => _.isBlank(model.min)),
                decimal,
                optionalBetween: optionalBetween('min', function (max) {
                    return Number(max) >= Number(this.min);
                }),
            },
        },
        methods: {
            getInitialState() {
                const {
                    op, min, max, value,
                } = this.condition.data;
                let minValue = null;
                let maxValue = null;
                if (op === ConditionOperators.between) {
                    minValue = min;
                    maxValue = max;
                } else if (op === ConditionOperators.gte) {
                    minValue = value;
                } else if (op === ConditionOperators.lte) {
                    maxValue = value;
                }
                return {min: minValue, max: maxValue};
            },
            applyFilter() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    let data = null;
                    if (_.isBlank(this.min) && _.isBlank(this.max)) {
                        return;
                    }
                    if (!_.isBlank(this.min) && !_.isBlank(this.max)) {
                        data = {
                            op: ConditionOperators.between,
                            min: Number(this.min),
                            max: Number(this.max),
                        };
                    } else if (!_.isBlank(this.min)) {
                        data = {
                            op: ConditionOperators.gte,
                            value: Number(this.min),
                        };
                    } else if (!_.isBlank(this.max)) {
                        data = {
                            op: ConditionOperators.lte,
                            value: Number(this.max),
                        };
                    }
                    this.condition.data = new CriteriaCondition({
                        ...data,
                        path: this.condition.data.getPath(),
                    });
                    this.$emit('apply-filter', {
                        index: this.index,
                        condition: this.condition,
                    });
                }
            },
        },
    };
</script>
